import React from "react";
import { Box, Grid, Typography, TextField, InputAdornment } from "@mui/material";
import { alpha } from "@mui/system";
import { AttachMoney } from "@mui/icons-material";

const MoneyField = ({ label, field, value, onChange }) => {
	const handleChange = (e) => {
		const val = e.target.value;
		if (val === "" || /^\d*[.,]?\d{0,2}$/.test(val)) onChange(field, val);
	};

	return (
		<Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
			<Typography variant="body2" sx={{ color: "text.secondary", fontWeight: 600 }}>
				{label}
			</Typography>
			<TextField
				size="small"
				fullWidth
				value={value}
				onChange={handleChange}
				InputProps={{
					startAdornment: (
						<InputAdornment position="start">
							<Typography variant="body2" sx={{ fontWeight: 600, color: "text.secondary" }}>
								R$
							</Typography>
						</InputAdornment>
					),
				}}
			/>
		</Box>
	);
};

export default function TarifacaoSection({ theme, tarifacaoValores, setTarifacaoValores }) {
	const handleChange = (field, value) => {
		setTarifacaoValores((prev) => ({ ...prev, [field]: value }));
	};

	return (
		<Box
			sx={{
				p: 2,
				bgcolor: theme.palette.background.paper,
				borderRadius: "12px",
				width: "100%",
				mb: 1,
			}}
		>
			{/* Cabeçalho */}
			<Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
				<Box
					sx={{
						backgroundColor: alpha(theme.palette.primary.main, 0.2),
						borderRadius: "10px",
						width: "35px",
						height: "35px",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
					}}
				>
					<AttachMoney
						fontSize="small"
						sx={{
							color:
								theme.palette.mode === "dark"
									? theme.palette.primary.light
									: theme.palette.primary.dark,
						}}
					/>
				</Box>
				<Typography variant="h6" sx={{ fontWeight: "bold", fontSize: "16px" }}>
					Tarifação 95th
				</Typography>
			</Box>

			<Grid container spacing={2} sx={{ mt: 1 }}>
				<Grid item xs={12}>
					<MoneyField
						label="Valor por Mbps (R$/Mbps)"
						field="valorPorMbps"
						value={tarifacaoValores.valorPorMbps}
						onChange={handleChange}
					/>
				</Grid>
				<Grid item xs={12} sm={6}>
					<Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
						<Typography
							variant="body2"
							sx={{ color: "text.secondary", fontWeight: 600 }}
						>
							Plano contratado (Mbps)
						</Typography>
						<TextField
							size="small"
							fullWidth
							value={tarifacaoValores.planoContratadoMbps}
							onChange={(e) => {
								const val = e.target.value;
								if (val === "" || /^\d*[.,]?\d*$/.test(val))
									handleChange("planoContratadoMbps", val);
							}}
						/>
					</Box>
				</Grid>
				<Grid item xs={12} sm={6}>
					<MoneyField
						label="Valor por Mbps excedente (R$/Mbps)"
						field="valorMbpsExcedente"
						value={tarifacaoValores.valorMbpsExcedente}
						onChange={handleChange}
					/>
				</Grid>
			</Grid>
		</Box>
	);
}
